export type LogEntry = { message: string; error?: unknown } & Record<
  string,
  unknown
>;

export interface Logger {
  debug(args: LogEntry): void;
  info(args: LogEntry): void;
  warn(args: LogEntry): void;
  error(args: LogEntry): void;
}

const Log: Logger = {
  debug(args) {
    console.debug(args.message, args);
  },
  info(args) {
    console.log(args.message, args);
  },
  warn(args) {
    console.warn(args.message, args);
  },
  error(args) {
    console.error(args.message, args);
  },
};

export default Log;
